'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMemo } from 'react'
import { TierLevels, type User } from 'types/session/user'

import { TITLE_LABELS_TIERS } from '../constants/statusModule'
import { LABELS_TIERS } from '../constants/tiers'

export const useStatusModule = ({
	userDetails,
}: {
	userDetails: User | null | undefined
}) => {
	const { t } = useLabels()

	return useMemo(() => {
		const likes = userDetails?.loyalty?.likes

		const totalLikes = likes?.total
		const annualNetExpense = likes?.annualNetExpense
		const tier = likes?.tier

		const tiersStructure = tier?.tiersStructure
		const tierTitle = t(TITLE_LABELS_TIERS[tier?.tier ?? TierLevels.TIER_1])

		const progressBarMax =
			tiersStructure && tiersStructure[tiersStructure?.length - 1].threshold
		const progressBarSteps = tiersStructure?.map(({ threshold, level }) => ({
			threshold,
			text: t(LABELS_TIERS[level]),
		}))

		return {
			totalLikes,
			annualNetExpense,
			tierTitle,
			progressBarSteps,
			progressBarMax,
		}
	}, [userDetails])
}
